import React from 'react';
import { Link } from 'react-router-dom';

import { getClickAttrs } from '../../Analytics/gtag';

import { clickCategories, clickLocations } from '../../../utils/analytics';
import { navigationIDs } from '../../Analytics/testIDConfig';
import TrackedClick from '../../Analytics/TrackedClick';
import Img from '../../Img';

import styles from '../header.scss';

const DesktopIconButton = ({ label, icon, to, navId, notificationDot }) => {
    return (
        <div className={`${styles.postWrapper}`}>
            <TrackedClick
                eventName="Header CTA Clicked"
                label={label}
                traits={{
                    container: clickCategories.HEADER,
                    uxType: 'link',
                    content: label,
                }}
            >
                <Link
                    className={`${styles.navIconLink} ${styles.desktop}`}
                    to={to}
                    {...getClickAttrs({
                        category: clickCategories.HEADER,
                        context: label,
                        location: clickLocations.HEADER_CTA,
                        testid: `${navigationIDs[navId].component}-${navigationIDs[navId].location}-${navigationIDs[navId].id}`,
                    })}
                >
                    <Img src={icon} />
                    {notificationDot
                        ? <div className="notification-dot" /> : null}
                </Link>
            </TrackedClick>
        </div>
    );
};

export default DesktopIconButton;
